import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {lightTheme} from '../../../libs/shared/ui/src/theme/light/lightTheme';
import {SettingsNavItemCommonStyleProps} from './settingsMenuCommonTypes';

const StyledNavItemHeadingDiv = styled.div<SettingsNavItemCommonStyleProps>`
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.bold};
  color: ${(p) => p.$theme.itemBold};
`;
export const SettingsNavItemHeading: FC = (props) => (
  <StyledNavItemHeadingDiv $theme={lightTheme}>{props.children}</StyledNavItemHeadingDiv>
);
